import { InstallationLubricantPluginService } from './lubricant.service';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'installation-lubricant-edit',
    templateUrl: './lubricant-edit.component.html',
    standalone: false
})
export class InstallationLubricantEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  private itemToRemove: number;

  @ViewChild('itemDeleteConfirm', { static: true }) itemDeleteConfirm: ConfirmComponent;

  private sub = new Subscription();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected fb: UntypedFormBuilder,
    private pluginService: InstallationLubricantPluginService
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['lubricants'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateLubricant(this.inspectionId, this.pointId, this.pluginId, model.lubricants)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['lubricants'];
    control.push(this.initItem());
  }

  public openItemDeleteConfirm(i: number) {
    this.itemDeleteConfirm.open();
    this.itemToRemove = i;
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['lubricants'];
    control.removeAt(this.itemToRemove);
  }

  public openMenu() {
    this.menuModal.modalFooter = false;
    this.menuModal.modalHeader = false;
    this.menuModal.modalMessage = false;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      lubricants: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['lubricants'];
    _.forEach(this.plugin.config.Lubricants, (el) => {
      control.push(this.initItem(el));
    });
  }

  private initItem(el?: any) {
    return this.fb.group({
      Brand: new UntypedFormControl(el && el.Brand ? el.Brand : ''),
      Type: new UntypedFormControl(el && el.Type ? el.Type : ''),
      Viscosity: new UntypedFormControl(el && el.Viscosity ? el.Viscosity : '')
    });
  }
}
